import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import './assest/css/Custom.css';
import './assest/css/StickyTable.css';
import { SimpleRoute } from './Routes/AuthRoute';
import { AuthRoute } from './Routes/SimpleRoutes';
import { PublicRoutes } from './Routes/PublicRoute';
import { Provider } from 'react-redux';
import store from './Store';
import { ToastContainer } from 'react-toastify';
import { HelmetProvider } from 'react-helmet-async';
import { SidebarMenu } from './Menu';
import {
  adsenseConfig,
  reportAdsenseProblems,
} from './Comopnent/GoogleAds/adsenseConfig';

// Sprint 18. Says once, as the app starts, when an AdSense setting was
// refused for its shape. Silent when ads are simply not set up.
reportAdsenseProblems(adsenseConfig());

// Create the router instance with all route configurations
const router = createBrowserRouter([
  ...PublicRoutes,
  ...SimpleRoute,
  ...AuthRoute,
]);

const rootElement = document.getElementById('root') as HTMLElement;

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <ToastContainer />
        <RouterProvider router={router} />
      </HelmetProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
